import Vue from 'vue'
import VueRouter from 'vue-router'
import { activity } from './activity'
import { investment } from './investment'
import miscRoute from './misc'

Vue.use(VueRouter)

const routes = [
  ...activity,
  ...investment,
  ...miscRoute,
  {
    path: '/',
    name: 'Home',
    redirect: {
      name: 'CommonIndexHome'
    }
  },
  {
    path: '/slider-vertify',
    name: 'CommonSliderVertify',
    component: () => import(/* webpackChunkName: "CommonSliderVertify" */ '../views/common/slider-vertify.vue'),
    meta: {
      title: '验证码'
    }
  },
  {
    path: '/service/robot',
    name: 'CommonCustomerServiceRobot',
    component: () => import(/* webpackChunkName: "CommonCustomerServiceRobot" */ '../views/common/service/robot.vue'),
    meta: {
      title: '智能客服'
    }
  },
  {
    path: '/404',
    name: 'CommonEmpty',
    component: () => import(/* webpackChunkName: "CommonEmpty" */ '../views/common/empty.vue')
  },
  {
    path: '/loading',
    name: 'CommonLoading',
    component: () => import(/* webpackChunkName: "CommonLoading" */ '../views/common/loading.vue'),
    meta: {
      title: '普泽基金'
    }
  },
  {
    path: '/diff-fund-loading',
    name: 'CommonDiffFundLoading',
    component: () => import(/* webpackChunkName: "CommonDiffFundLoading" */ '../views/common/diffFundLoading.vue'),
    meta: {
      title: '普泽基金'
    }
  },
  {
    path: '/notice',
    name: 'Notice',
    component: () => import(/* webpackChunkName: "CommonNotice" */ '../views/common/notice.vue'),
    meta: {
      title: '公告详情'
    }
  },
  {
    path: '/notice-detail',
    name: 'CommonNoticeNoticeDetail',
    component: () => import(/* webpackChunkName: "CommonNoticeNoticeDetail" */ '../views/common/notice-detail.vue'),
    meta: {
      title: '公告详情'
    }
  },
  {
    path: '/for-app',
    name: 'ForApp',
    component: () => import(/* webpackChunkName: "CommonForApp" */ '../views/common/down-app.vue'),
    meta: {
      title: '下载普泽基金APP'
    }
  },
  {
    path: '/invest-suitable-question',
    name: 'InvestSuitableQuestion',
    component: () => import(/* webpackChunkName: "InvestSuitableQuestion" */ '../views/common/invest-suitable-question.vue'),
    meta: {
      title: '投资者适当性问卷调查'
    }
  },
  {
    path: '/down-app',
    name: 'DownApp',
    component: () => import(/* webpackChunkName: "DownApp" */ '../views/common/down-app.vue'),
    meta: {
      title: '下载普泽基金APP'
    }
  },
  {
    path: '/share-real',
    name: 'ShareReal',
    component: () => import(/* webpackChunkName: "ShareReal" */ '../views/common/share-real.vue'),
    meta: {
      title: '下载普泽基金APP'
    }
  },
  {
    path: '/common',
    name: 'CommonIndex',
    component: () => import(/* webpackChunkName: "CommonIndex" */ '../views/common/index.vue'),
    meta: {
      title: '基金筛选'
    },
    redirect: {
      name: 'CommonIndexHome'
    },
    children: [
      {
        path: 'mine',
        name: 'CommonIndexMine',
        component: () => import(/* webpackChunkName: "CommonIndexMine" */ '../views/common/myself.vue'),
        meta: {
          title: '我的'
        }
      },
      // {
      //   path: 'statistics',
      //   name: 'CommonIndexStatistics',
      //   component: () => import(/* webpackChunkName: "CommonIndexMine" */ '../views/common/revenue-statistics.vue'),
      //   meta: {
      //     title: '收益统计'
      //   }
      // },
      {
        path: 'home',
        name: 'CommonIndexHome',
        component: () => import(/* webpackChunkName: "CommonIndexHome" */ '../views/fund/ranking.vue'),
        meta: {
          title: '基金筛选'
        },
        children: [
          {
            path: 'search',
            name: 'FundRankingSearch',
            component: () => import(/* webpackChunkName: "FundRankingSearch" */ '../views/fund/search.vue'),
            meta: {
              title: '基金筛选'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/ranking',
    name: 'CommonIndexRanking',
    component: () => import(/* webpackChunkName: "CommonIndexRanking" */ '../views/fund/ranking.vue'),
    meta: {
      title: '基金筛选'
    },
    children: [
      {
        path: 'search',
        name: 'CommonIndexRankingSearch',
        component: () => import(/* webpackChunkName: "CommonIndexRankingSearch" */ '../views/fund/search.vue'),
        meta: {
          title: '基金筛选'
        }
      }
    ]
  },
  {
    path: '/ranking-steady',
    name: 'CommonIndexRankingSteady',
    component: () => import(/* webpackChunkName: "CommonIndexRankingSteady" */ '../views/fund/ranking.vue'),
    meta: {
      title: '稳健投资'
    },
    children: [
      {
        path: 'search',
        name: 'CommonIndexRankingSteadySearch',
        component: () => import(/* webpackChunkName: "CommonIndexRankingSteadySearch" */ '../views/fund/search.vue'),
        meta: {
          title: '基金筛选'
        }
      }
    ]
  },
  {
    path: '/ranking-advance',
    name: 'CommonIndexRankingAdvance',
    component: () => import(/* webpackChunkName: "CommonIndexRankingAdvance" */ '../views/fund/ranking.vue'),
    meta: {
      title: '进阶投资'
    },
    children: [
      {
        path: 'search',
        name: 'CommonIndexRankingAdvanceSearch',
        component: () => import(/* webpackChunkName: "CommonIndexRankingAdvanceSearch" */ '../views/fund/search.vue'),
        meta: {
          title: '基金筛选'
        }
      }
    ]
  },
  {
    path: '/mine',
    name: 'CommonIndexMineSelf',
    component: () => import(/* webpackChunkName: "CommonIndexMineSelf" */ '../views/common/myself.vue'),
    meta: {
      title: '我的'
    }
  },
  {
    path: '/common/rule/single',
    name: 'CommonRuleSingle',
    component: () => import(/* webpackChunkName: "CommonRuleSingle" */ '../views/common/rule/single.vue'),
    meta: {
      title: '相关协议和说明'
    }
  },
  {
    path: '/common/rule/multiple',
    name: 'CommonRuleMultiple',
    component: () => import(/* webpackChunkName: "CommonRuleMultiple" */ '../views/common/rule/multiple.vue'),
    meta: {
      title: '相关协议和说明'
    }
  },
  {
    path: '/common/rule/content',
    name: 'CommonRuleContent',
    component: () => import(/* webpackChunkName: "CommonRuleContent" */ '../views/common/rule/content.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/common/rule/content2',
    name: 'CommonRuleContent2',
    component: () => import(/* webpackChunkName: "CommonRuleContent2" */ '../views/common/rule/content2.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/common/rule/maintain',
    name: 'CommonRuleMaintain',
    component: () => import(/* webpackChunkName: "CommonRuleMaintain" */ '../views/common/rule/maintain.vue'),
    meta: {
      title: '客户维护费'
    }
  },
  {
    path: '/common/rule/risk',
    name: 'CommonRuleRisk',
    component: () => import(/* webpackChunkName: "CommonRuleRisk" */ '../views/common/rule/risk.vue'),
    meta: {
      title: '风险揭示书'
    }
  },
  {
    path: '/common/rule/risk-level',
    name: 'CommonRuleRiskLevel',
    component: () => import(/* webpackChunkName: "CommonRuleRiskLevel" */ '../views/common/rule/risk-level.vue'),
    meta: {
      title: '宜信普泽基金产品风险等级评定管理办法'
    }
  },
  {
    path: '/setting',
    name: 'CommonSetting',
    component: () => import(/* webpackChunkName: "CommonSetting" */ '../views/common/setUp.vue'),
    meta: {
      title: '设置'
    }
  },
  {
    path: '/about-us',
    name: 'CommonAboutUs',
    component: () => import(/* webpackChunkName: "CommonAboutUs" */ '../views/common/about-us.vue'),
    meta: {
      title: '关于我们'
    }
  },
  {
    path: '/account/auth-center',
    name: 'AccountAuthCenter',
    component: () => import(/* webpackChunkName: "AccountAuthCenter" */ '../views/account/auth-center.vue'),
    meta: {
      title: '认证中心'
    }
  },
  {
    path: '/account/real-auth',
    name: 'AccountRealAuth',
    component: () => import(/* webpackChunkName: "AccountRealAuth" */ '../views/account/real-auth.vue'),
    meta: {
      title: '实名认证'
    }
  },
  {
    path: '/account/ocr',
    name: 'AccountOcr',
    component: () => import(/* webpackChunkName: "AccountOcr" */ '../views/account/ocr.vue'),
    meta: {
      title: '基金开户'
    }
  },
  {
    path: '/account/out-man',
    name: 'AccountOutMan',
    component: () => import(/* webpackChunkName: "AccountOutMan" */ '../views/account/out-man.vue'),
    meta: {
      title: '基金开户'
    }
  },
  {
    path: '/account/verification-user',
    name: 'AccountVerificationUser',
    component: () => import(/* webpackChunkName: "AccountVerificationUser" */ '../views/account/verification-user.vue'),
    meta: {
      title: '身份认证'
    },
    children: [
      {
        path: 'choose-bank',
        name: 'AccountVerificationUserChooseBank',
        component: () => import(/* webpackChunkName: "AccountVerificationUserChooseBank" */ '../views/account/choose-bank.vue'),
        meta: {
          title: '选择银行'
        }
      }
    ]
  },
  {
    path: '/account/authentication/bank',
    name: 'AuthenticationBank',
    component: () => import(/* webpackChunkName: "AuthenticationBank" */ '../views/account/authentication/bank.vue'),
    meta: {
      title: '银行卡认证'
    }
  },
  {
    path: '/account/authentication/bank-result',
    name: 'AuthenticationBankResult',
    component: () => import(/* webpackChunkName: "AuthenticationBankResult" */ '../views/account/authentication/bank-result.vue'),
    meta: {
      title: '认证结果'
    }
  },
  {
    path: '/account/bind-bank',
    name: 'AccountBindBank',
    component: () => import(/* webpackChunkName: "AccountBindBank" */ '../views/account/bank/bind.vue'),
    meta: {
      title: '绑定银行卡',
      keepAlive: true
    },
    children: [
      {
        path: 'branch',
        name: 'AccountBankCardBranch',
        meta: {
          title: '开户支行'
        },
        component: () => import(/* webpackChunkName: "AccountBankCardBranch" */ '../views/account/bank/branch.vue')
      }
    ]
  },
  {
    path: '/account/bank-card',
    name: 'AccountBankCard',
    meta: {
      title: '银行卡'
    },
    component: () => import(/* webpackChunkName: "AccountBankCard" */ '../views/account/bank/card.vue')
  },
  {
    path: '/account/bank-card/detail',
    name: 'AccountBankCardDetail',
    meta: {
      title: '银行卡管理'
    },
    component: () => import(/* webpackChunkName: "AccountBankCardDetail" */ '../views/account/bank/card-detail.vue')
  },
  {
    path: '/account/bank-sign',
    name: 'AccountBankSign',
    meta: {
      title: '开通快捷支付'
    },
    component: () => import(/* webpackChunkName: "AccountBankSign" */ '../views/account/bank/sign.vue')
  },
  {
    path: '/account/bank/change',
    name: 'AccountBankChange',
    meta: {
      title: '更换银行卡'
    },
    component: () => import(/* webpackChunkName: "AccountBankChange" */ '../views/account/bank/change.vue')
  },
  {
    path: '/account/bank/change-form',
    name: 'AccountBankChangeForm',
    meta: {
      title: '添加银行卡'
    },
    component: () => import(/* webpackChunkName: "AccountBankChangeForm" */ '../views/account/bank/change-form.vue'),
    children: [
      {
        path: 'branch',
        name: 'AccountBankchangeFormBranch',
        meta: {
          title: '开户支行'
        },
        component: () => import(/* webpackChunkName: "AccountBankchangeFormBranch" */ '../views/account/bank/branch.vue')
      }
    ]
  },
  {
    path: '/account/bank/change-information',
    name: 'AccountBankChangeinformation',
    meta: {
      title: '换卡材料'
    },
    component: () => import(/* webpackChunkName: "AccountBankChangeinformation" */ '../views/account/bank/change-information.vue'),
    children: [
      {
        path: 'detail',
        name: 'AccountBankChangeinformationDetail',
        meta: {
          title: '示例文件'
        },
        component: () => import(/* webpackChunkName: "AccountBankChangeinformationDetail" */ '../views/account/bank/change-information-detail.vue')
      }
    ]
  },
  {
    path: '/account/bank/change-result',
    name: 'AccountBankChangeResult',
    meta: {
      title: '更换银行卡'
    },
    component: () => import(/* webpackChunkName: "AccountBankChangeResult" */ '../views/account/bank/change-result.vue')
  },
  {
    path: '/account/bank/change-result-fail',
    name: 'AccountBankChangeResultFail',
    meta: {
      title: '更换银行卡'
    },
    component: () => import(/* webpackChunkName: "AccountBankChangeResultFail" */ '../views/account/bank/change-result-fail.vue')
  },
  {
    path: '/account/transpwd',
    name: 'AccountTransPwd',
    component: () => import(/* webpackChunkName: "AccountTransPwd" */ '../views/account/transpwd/index.vue'),
    meta: {
      title: '交易密码'
    }
  },
  {
    path: '/account/loginpwd',
    name: 'AccountLoginPwd',
    component: () => import(/* webpackChunkName: "AccountLoginPwd" */ '../views/account/loginpwd/index.vue'),
    meta: {
      title: '登录密码'
    }
  },
  {
    path: '/account/complete-information',
    name: 'AccountCompleteInformation',
    component: () => import(/* webpackChunkName: "AccountCompleteInformation" */ '../views/account/complete-information.vue'),
    meta: {
      title: '个人信息'
    },
    children: [
      {
        path: 'beneficiary',
        name: 'AccountCompleteInformationBeneficiary',
        component: () => import(/* webpackChunkName: "AccountCompleteInformationBeneficiary" */ '../views/account/beneficiary.vue'),
        meta: {
          title: '受益所有人是否本人'
        }
      },
      {
        path: 'control',
        name: 'AccountCompleteInformationControl',
        component: () => import(/* webpackChunkName: "AccountCompleteInformationControl" */ '../views/account/beneficiary.vue'),
        meta: {
          title: '实际控制人是否本人'
        }
      }
    ]
  },
  {
    path: '/account/complete-crs-information',
    name: 'AccountCompleteCrsInformation',
    component: () => import(/* webpackChunkName: "AccountCompleteCrsInformation" */ '../views/account/complete-crs-information.vue'),
    meta: {
      title: '基金开户'
    }
  },
  {
    path: '/account/risk-assessment',
    name: 'AccountRiskAssessment',
    component: () => import(/* webpackChunkName: "AccountRiskAssessment" */ '../views/account/risk-assessment.vue'),
    meta: {
      title: '风险测评',
      keepAlive: true
    }
  },
  {
    path: '/risk-assessment-result',
    name: 'AccountRiskAssessmentResult',
    component: () => import(/* webpackChunkName: "AccountRiskAssessmentResult" */ '../views/account/risk-assessment-result.vue'),
    meta: {
      title: '风险测评'
    }
  },
  {
    path: '/risk-assessment-result2',
    name: 'AccountRiskAssessmentResult2',
    component: () => import(/* webpackChunkName: "AccountRiskAssessmentResult2" */ '../views/account/risk-assessment-result2.vue'),
    meta: {
      title: '风险测评'
    }
  },
  {
    path: '/risk-assessment-hold',
    name: 'AccountRiskAssessmentHold',
    component: () => import(/* webpackChunkName: "AccountRiskAssessmentHold" */ '../views/account/risk-assessment-hold.vue'),
    meta: {
      title: '普泽基金'
    }
  },
  {
    path: '/choose-bank',
    name: 'ChooseBank',
    component: () => import(/* webpackChunkName: "ChooseBank" */ '../views/account/choose-bank.vue'),
    meta: {
      title: '选择银行',
      keepAlive: true
    }
  },
  {
    path: '/support-bank',
    name: 'SupportBank',
    component: () => import(/* webpackChunkName: "SupportBank" */ '../views/account/support-bank.vue'),
    meta: {
      title: '支持银行及限额（基金）'
    }
  },
  {
    path: '/login',
    name: 'AccountLogin',
    component: () => import(/* webpackChunkName: "AccountLogin" */ '../views/account/login/index.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/login-register',
    name: 'AccountLoginRegister',
    component: () => import(/* webpackChunkName: "AccountLoginRegister" */ '../views/account/login/index-register.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/register',
    name: 'AccountRegister',
    component: () => import(/* webpackChunkName: "AccountRegister" */ '../views/account/register/index.vue'),
    meta: {
      title: '注册'
    },
    children: [
      {
        path: 'subcode',
        name: 'AccountRegisterSubcode',
        component: () => import(/* webpackChunkName: "AccountRegisterSubcode" */ '../views/account/register/subcode.vue'),
        meta: {
          title: '注册'
        }
      }
    ]
  },
  {
    path: '/fund/detail',
    name: 'FundDetail',
    component: () => import(/* webpackChunkName: "FundDetail" */ '../views/fund/detail.vue'),
    meta: {
      title: '基金详情'
    }
  },
  /**
   * 货币基金详情
   */
  {
    path: '/fund/currency-fund-detail',
    name: 'CurrencyFundDetail',
    component: () => import(/* webpackChunkName: "CurrencyFundDetail" */ '../views/fund/currency-fund-detail.vue'),
    meta: {
      title: '基金详情'
    }
  },
  /**
   * 货币基金交易规则
   */
  {
    path: '/fund/currency-trade-rules',
    name: 'CurrencyTradeRules',
    component: () => import(/* webpackChunkName: "CurrencyTradeRules" */ '../views/fund/currency-trade-rules.vue'),
    meta: {
      title: '基金详情'
    }
  },
  {
    path: '/fund/achievement',
    name: 'FundDetailAchievement',
    component: () => import(/* webpackChunkName: "FundDetailAchievement" */ '../views/fund/history/achievement.vue'),
    meta: {
      title: '历史业绩'
    }
  },
  {
    path: '/fund/net-value',
    name: 'FundDetailNetValue',
    component: () => import(/* webpackChunkName: "FundDetailNetValue" */ '../views/fund/history/net-value.vue'),
    meta: {
      title: '历史净值'
    }
  },
  {
    path: '/fund/manager',
    name: 'FundDetailManager',
    component: () => import(/* webpackChunkName: "FundDetailManager" */ '../views/fund/manager/index.vue'),
    meta: {
      title: '基金经理'
    }
  },
  {
    path: '/fund/document',
    name: 'FundDetailDocument',
    component: () => import(/* webpackChunkName: "FundDetailDocument" */ '../views/fund/document/index.vue'),
    meta: {
      title: '基金档案'
    }
  },
  {
    path: '/fund/document/ggdetail',
    name: 'GongGaoDetail',
    component: () => import(/* webpackChunkName: "GongGaoDetail" */ '../views/fund/document/gongGaoDetail.vue'),
    meta: {
      title: '文章详情'
    }
  },
  {
    path: '/fund/trading-rules',
    name: 'FundDetailTradingRules',
    component: () => import(/* webpackChunkName: "FundDetailTradingRules" */ '../views/fund/trading-rules.vue'),
    meta: {
      title: '交易规则'
    },
    children: [
      {
        path: 'notice',
        name: 'FundDetailTradingRulesNotice',
        component: () => import(/* webpackChunkName: "FundDetailTradingRulesNotice" */ '../views/fund/trading-rules-notice.vue'),
        meta: {
          title: '交易规则'
        }
      }
    ]
  },
  {
    path: '/fund/buy',
    name: 'FundBuy',
    component: () => import(/* webpackChunkName: "FundBuy" */ '../views/fund/buy.vue'),
    meta: {
      title: '买入'
    }
  },
  {
    path: '/fund/buy-result',
    name: 'FundBuyResult',
    component: () => import(/* webpackChunkName: "FundBuyResult" */ '../views/fund/buy-result.vue'),
    meta: {
      title: '买入结果'
    }
  },
  {
    path: '/fund/buy-chaobao-payment-result',
    name: 'FundBuyChaobaoPaymentResult',
    component: () => import(/* webpackChunkName: "FundBuyChaobaoPaymentResult" */ '../views/fund/buy-chaobao-payment-result.vue'),
    meta: {
      title: '买入结果'
    }
  },
  {
    path: '/fund/sell',
    name: 'FundSell',
    component: () => import(/* webpackChunkName: "FundSell" */ '../views/fund/sell.vue'),
    meta: {
      title: '卖出'
    },
    children: [
      {
        path: 'expire-detail',
        name: 'FundSellExpireDetail',
        component: () => import(/* webpackChunkName: "FundSellExpireDetail" */ '../views/fund/expire-detail.vue'),
        meta: {
          title: '份额到期明细'
        }
      },
      {
        path: '/fund/sell/fund-select',
        name: 'FundSellFunSelect',
        meta: {
          title: '选择充值基金'
        },
        component: () => import(/* webpackChunkName: "newYqbFunSelect" */ '../views/new-yqb/fund-select.vue')
      },
      {
        path: 'jyzh',
        name: 'FundJYZH',
        component: () => import(/* webpackChunkName: "FundSellExpireDetail" */ '../views/fund/jyzh.vue'),
        meta: {
          title: '什么是交易账户'
        }
      }
    ]
  },
  {
    path: '/fund/sell-result',
    name: 'FundSellResult',
    component: () => import(/* webpackChunkName: "FundSellResult" */ '../views/fund/sell-result.vue'),
    meta: {
      title: '卖出'
    }
  },
  {
    path: '/fund/remittance-instructions',
    name: 'FundRemittanceInstructions',
    component: () => import(/* webpackChunkName: "FundRemittanceInstructions" */ '../views/fund/remittance-instructions.vue'),
    meta: {
      title: '汇款交易使用说明'
    }
  },
  {
    path: '/fund/large-attention',
    name: 'LargeAttention',
    component: () => import(/* webpackChunkName: "FundRemittanceInstructions" */ '../views/fund/large-attention.vue'),
    meta: {
      title: '大额汇款注意事项'
    }
  },
  {
    path: '/fund/buy-result-instructions',
    name: 'FundBuyResultInstructions',
    component: () => import(/* webpackChunkName: "FundBuyResultInstructions" */ '../views/fund/buy-result-large.vue'),
    meta: {
      title: '大额汇款'
    }
  },
  {
    path: '/my-fund-position',
    name: 'myFundPosition',
    component: () => import(/* webpackChunkName: "myFundPosition" */ '../views/my-fund-position/index.vue'),
    meta: {
      title: '公募基金'
    }
  },
  {
    path: '/monitor-oscillation',
    name: 'MonitorOscillation',
    component: () => import(/* webpackChunkName: "myFundPosition" */ '../views/my-fund-position/monitorOscillation.vue'),
    meta: {
      title: '热点动态'
    }
  },
  {
    path: '/income',
    name: 'income',
    component: () => import(/* webpackChunkName: "incomeDetail" */ '../views/my-fund-position/income.vue'),
    meta: {
      title: '收益明细'
    },
    redirect: {
      name: 'incomeCalendar'
    },
    children: [
      {
        path: 'income-calendar',
        name: 'incomeCalendar',
        component: () => import(/* webpackChunkName: "incomeDetail" */ '../views/my-fund-position/income-calendar.vue'),
        meta: {
          title: '收益明细'
        }
      },
      {
        path: 'income-detail',
        name: 'incomeDetail',
        component: () => import(/* webpackChunkName: "incomeDetail" */ '../views/my-fund-position/income-detail.vue'),
        meta: {
          title: '收益明细'
        }
      }
    ]
  },
  {
    path: '/history-income',
    name: 'historyIncome',
    component: () => import('../views/my-fund-position/history-income.vue'),
    meta: {
      title: '收益明细'
    }
  },
  {
    path: '/transaction-log',
    name: 'transactionLog',
    component: () => import(/* webpackChunkName: "transactionLog" */ '../views/my-fund-position/transaction-log.vue'),
    meta: {
      title: '交易记录'
    }
  },
  {
    path: '/history-log',
    name: 'historyLog',
    component: () => import(/* webpackChunkName: "historyLog" */ '../views/my-fund-position/history-log'),
    meta: {
      title: '历史交易记录'
    }
  },
  // history-bonus-detail
  {
    path: '/history-bonus-detail',
    name: 'historyBonusDetail',
    component: () => import(/* webpackChunkName: "historyBonusDetail" */ '../views/my-fund-position/history-bonus-detail'),
    meta: {
      title: '记录详情'
    }
  },
  {
    path: '/history-log-detail',
    name: 'historyLogDetail',
    component: () => import(/* webpackChunkName: "historyLogDetail" */ '../views/my-fund-position/history-log-detail'),
    meta: {
      title: '记录详情'
    }
  },
  {
    path: '/transaction-all-log',
    name: 'transactionAllLog',
    component: () => import(/* webpackChunkName: "transactionAllLog" */ '../views/my-fund-position/transaction-all-log.vue'),
    meta: {
      title: '交易记录'
    }
  },
  {
    path: '/transaction-log/detail',
    name: 'transactionLogDetailView',
    component: () => import(/* webpackChunkName: "transactionLogDetailView" */ '../views/my-fund-position/transaction-log-detailview.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/transaction-log/detail-ztg',
    name: 'transactionLogDetailZTG',
    component: () => import(/* webpackChunkName: "transactionLogDetailZTG" */ '../views/my-fund-position/records/ztg.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/transaction-log/detail-rg',
    name: 'transactionLogDetailRG',
    component: () => import(/* webpackChunkName: "transactionLogDetailRG" */ '../views/my-fund-position/records/rg.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/transaction-log/detail-mr',
    name: 'transactionLogDetailMR',
    component: () => import(/* webpackChunkName: "transactionLogDetailMR" */ '../views/my-fund-position/records/mr.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/transaction-log/detail-son',
    name: 'transactionLogDetailViewSon',
    component: () => import(/* webpackChunkName: "transactionLogDetailViewSon" */ '../views/my-fund-position/son/order-son.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/transaction-log/detail-son-ztg',
    name: 'transactionLogDetailViewSonZTG',
    component: () => import(/* webpackChunkName: "transactionLogDetailViewSonZTG" */ '../views/my-fund-position/son/order-son-ztg.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/transaction-log/detail-son-mr',
    name: 'transactionLogDetailViewSonMR',
    component: () => import(/* webpackChunkName: "transactionLogDetailViewSonMR" */ '../views/my-fund-position/son/order-son-mr.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/transaction-log/detail-son-mc',
    name: 'transactionLogDetailViewSonMC',
    component: () => import(/* webpackChunkName: "transactionLogDetailViewSonMC" */ '../views/my-fund-position/son/order-son-mc.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/transaction-log/detail-son-rg',
    name: 'transactionLogDetailViewSonRG',
    component: () => import(/* webpackChunkName: "transactionLogDetailViewSonRG" */ '../views/my-fund-position/son/order-son-rg.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/transaction-log/detail-son-dt',
    name: 'transactionLogDetailViewSonDT',
    component: () => import(/* webpackChunkName: "transactionLogDetailViewSonDT" */ '../views/my-fund-position/son/order-son-dt.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/transaction-log/detail-son-qs',
    name: 'transactionLogDetailViewSonQS',
    component: () => import(/* webpackChunkName: "transactionLogDetailViewSonQS" */ '../views/my-fund-position/son/order-son-qs.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/transaction-log/detail-son-qp',
    name: 'transactionLogDetailViewSonQP',
    component: () => import(/* webpackChunkName: "transactionLogDetailViewSonQP" */ '../views/my-fund-position/son/order-son-qp.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/transaction-log/detail-son-qj',
    name: 'transactionLogDetailViewSonQJ',
    component: () => import(/* webpackChunkName: "transactionLogDetailViewSonQJ" */ '../views/my-fund-position/son/order-son-qj.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/transaction-log/detail-son-qz',
    name: 'transactionLogDetailViewSonQZ',
    component: () => import(/* webpackChunkName: "transactionLogDetailViewSonQZ" */ '../views/my-fund-position/son/order-son-qz.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/transaction-log/detail-son-fh',
    name: 'transactionLogDetailViewSonFH',
    component: () => import(/* webpackChunkName: "transactionLogDetailViewSonFH" */ '../views/my-fund-position/son/order-son-fh.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/transaction-log/detail-son-wztg',
    name: 'transactionLogDetailViewSonWZTG',
    component: () => import(/* webpackChunkName: "transactionLogDetailViewSonWZTG" */ '../views/my-fund-position/son/order-son-wztg.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/set-bonus',
    name: 'setBonus',
    component: () => import(/* webpackChunkName: "setBonus" */ '../views/my-fund-position/set-bonus.vue'),
    meta: {
      title: '修改分红方式'
    }
  },
  {
    path: '/yiqianbao/redeem',
    name: 'YiqianbaoRedeem',
    component: () => import(/* webpackChunkName: "YiqianbaoRedeem" */ '../views/yiqianbao/redeem.vue'),
    meta: {
      title: '活钱宝待赎回'
    }
  },
  {
    path: '/yiqianbao/document',
    name: 'YiqianbaoDetailDocument',
    component: () => import(/* webpackChunkName: "YiqianbaoDetailDocument" */ '../views/yiqianbao/document.vue'),
    meta: {
      title: '基金档案'
    }
  },
  {
    path: '/yiqianbao/notice',
    name: 'YiqianbaoDetailNotice',
    component: () => import(/* webpackChunkName: "YiqianbaoDetailNotice" */ '../views/yiqianbao/notice.vue'),
    meta: {
      title: '基金公告'
    }
  },
  {
    path: '/yiqianbao/manager',
    name: 'YiqianbaoDetailManager',
    component: () => import(/* webpackChunkName: "YiqianbaoDetailManager" */ '../views/yiqianbao/manager.vue'),
    meta: {
      title: '基金经理'
    }
  },
  {
    path: '/yiqianbao/company',
    name: 'YiqianbaoCompany',
    component: () => import(/* webpackChunkName: "YiqianbaoCompany" */ '../views/yiqianbao/company.vue'),
    meta: {
      title: '基金公司'
    }
  },
  {
    path: '/yiqianbao/buy',
    name: 'YiqianbaoBuy',
    component: () => import(/* webpackChunkName: "YiqianbaoBuy" */ '../views/yiqianbao/buy.vue'),
    meta: {
      title: '转入活钱宝'
    }
  },
  {
    path: '/yiqianbao/buy-result',
    name: 'YiqianbaoBuyResult',
    component: () => import(/* webpackChunkName: "YiqianbaoBuyResult" */ '../views/yiqianbao/buy-result.vue'),
    meta: {
      title: '买入结果'
    }
  },
  {
    path: '/yiqianbao/sell',
    name: 'YiqianbaoSell',
    component: () => import(/* webpackChunkName: "YiqianbaoSell" */ '../views/yiqianbao/sell.vue'),
    meta: {
      title: '卖出'
    }
  },
  {
    path: '/yiqianbao/sell-result',
    name: 'YiqianbaoSellResult',
    component: () => import(/* webpackChunkName: "YiqianbaoSellResult" */ '../views/yiqianbao/sell-result.vue'),
    meta: {
      title: '卖出'
    }
  },
  {
    path: '/yiqianbao/detail',
    name: 'YiqianbaoDetail',
    component: () => import(/* webpackChunkName: "YiqianbaoDetail" */ '../views/yiqianbao/detail.vue'),
    meta: {
      title: '基金详情'
    }
  },
  {
    path: '/yiqianbao/income',
    name: 'YiqianbaoIncome',
    component: () => import(/* webpackChunkName: "YiqianbaoIncome" */ '../views/yiqianbao/income.vue'),
    meta: {
      title: '收益记录'
    }
  },
  {
    path: '/yiqianbao/record',
    name: 'YiqianbaoRecord',
    component: () => import(/* webpackChunkName: "YiqianbaoRecord" */ '../views/yiqianbao/record.vue'),
    meta: {
      title: '交易记录'
    },
    children: [
      {
        path: 'detail',
        name: 'YiqianbaoRecordDetail',
        component: () => import(/* webpackChunkName: "YiqianbaoRecordDetail" */ '../views/yiqianbao/record-detail.vue'),
        meta: {
          title: '交易详情'
        }
      },
      {
        path: 'detail2',
        name: 'YiqianbaoRecordDetail2',
        component: () => import(/* webpackChunkName: "YiqianbaoRecordDetail2" */ '../views/yiqianbao/record-detail2.vue'),
        meta: {
          title: '交易详情'
        }
      }
    ]
  },
  {
    path: '/transaction-log-detail',
    name: 'transactionLogDetail',
    component: () => import(/* webpackChunkName: "FundBuyResult" */ '../views/my-fund-position/transaction-log-detail.vue'),
    meta: {
      title: '记录详情'
    }
  },
  {
    path: '/transaction-log-detail-transfer',
    name: 'transactionLogDetailTransfer',
    component: () => import(/* webpackChunkName: "transactionLogDetailTransfer" */ '../views/my-fund-position/transaction-log-detail-transfer.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/fund-position-detail',
    name: 'fundPositionDetail',
    component: () => import(/* webpackChunkName: "FundBuyResult" */ '../views/my-fund-position/fund-position-detail.vue'),
    meta: {
      title: '资产详情'
    }
  },
  {
    path: '/new-fund-list',
    name: 'newFundList',
    component: () => import(/* webpackChunkName: "newFundList" */ '../views/new-fund/list.vue'),
    meta: {
      title: '新发基金'
    }
  },
  {
    path: '/new-fund-detail',
    name: 'newFundDetail',
    component: () => import(/* webpackChunkName: "newFundDetail" */ '../views/new-fund/detail.vue'),
    meta: {
      title: '基金详情'
    }
  },
  {
    path: '/regular-invest/buy',
    name: 'regularInvestBuy',
    component: () => import(/* webpackChunkName: "regularInvest" */ '../views/regular-invest/buy.vue'),
    meta: {
      title: '定投'
    }
  },
  {
    path: '/regular-invest/plan',
    name: 'regularInvestPlan',
    component: () => import(/* webpackChunkName: "regularInvestPlan" */ '../views/regular-invest/plan.vue'),
    meta: {
      title: '定投计划'
    }
  },
  {
    path: '/regular-invest/plan-detail',
    name: 'regularInvestPlanDetail',
    component: () => import(/* webpackChunkName: "regularInvestPlanDetail" */ '../views/regular-invest/plan-detail.vue'),
    meta: {
      title: '定投详情'
    }
  },
  {
    path: '/regular-invest/history-plan',
    name: 'historyPlan',
    component: () => import('../views/regular-invest/history-plan.vue'),
    meta: {
      title: '历史记录'
    }
  },
  {
    path: '/regular-invest/buy-result',
    name: 'regularInvestBuyResult',
    component: () => import(/* webpackChunkName: "regularInvestBuyResult" */ '../views/regular-invest/buy-result.vue'),
    meta: {
      title: '定投计划'
    }
  },
  {
    path: '/regular-invest/info',
    name: 'regularInvestInfo',
    component: () => import('../views/regular-invest/info.vue'),
    meta: {
      title: '涨跌幅定投详情'
    }
  },
  {
    path: '/regular-invest/company',
    name: 'regularInvestCompany',
    component: () => import(/* webpackChunkName: "regularInvestCompany" */ '../views/new-fund/company.vue'),
    meta: {
      title: '基金公司'
    }
  },
  {
    path: '/new-fund/trading-rules',
    name: 'newFundDetailTradingRules',
    component: () => import(/* webpackChunkName: "newFundDetailTradingRules" */ '../views/new-fund/trading-rules.vue'),
    meta: {
      title: '交易规则'
    }
  },
  {
    path: '/new-fund/document',
    name: 'newFundDocument',
    component: () => import(/* webpackChunkName: "newFundDocument" */ '../views/new-fund/document.vue'),
    meta: {
      title: '基金档案'
    }
  },
  {
    path: '/progress-trade-list',
    name: 'ProgressTradeList',
    component: () => import(/* webpackChunkName: "ProgressTradeList" */ '../views/progress-trade/progress-trade-list.vue'),
    meta: {
      title: '在途交易'
    }
  },
  {
    path: '/progress-trade-detail',
    name: 'ProgressTradeDetail',
    component: () => import(/* webpackChunkName: "ProgressTradeDetail" */ '../views/progress-trade/progress-trade-detail.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/transfer-list',
    name: 'TransferList',
    component: () => import(/* webpackChunkName: "TransferList" */ '../views/progress-trade/transfer-list.vue'),
    meta: {
      title: '资产处理明细'
    }
  },
  {
    path: '/transfer-detail',
    name: 'TransferDetail',
    component: () => import(/* webpackChunkName: "TransferDetail" */ '../views/progress-trade/transfer-detail.vue'),
    meta: {
      title: '交易详情'
    }
  },
  {
    path: '/invest-advise-match',
    name: 'InvestAdviseMatch',
    component: () => import(/* webpackChunkName: "InvestAdviseMatch" */ '../views/invest-advise/invest-advise-match.vue'),
    meta: {
      title: '投顾策略匹配'
    }
  },
  {
    path: '/invest-advise-recommend',
    name: 'InvestAdviseRecommend',
    component: () => import(/* webpackChunkName: "InvestAdviseRecommend" */ '../views/invest-advise/invest-advise-recommend.vue'),
    meta: {
      title: '投顾策略推荐'
    }
  },
  {
    path: '/invest-advise-detail',
    name: 'InvestAdviseDetail',
    component: () => import(/* webpackChunkName: "InvestAdviseDetail" */ '../views/invest-advise/invest-advise-detail.vue'),
    meta: {
      title: '投顾方案详情'
    }
  },
  {
    path: '/invest-advise-common-question',
    name: 'InvestAdviseCommonQuestion',
    component: () => import(/* webpackChunkName: "InvestAdviseCommonQuestion" */ '../views/invest-advise/invest-advise-common-question.vue'),
    meta: {
      title: '常见问题'
    }
  },
  {
    path: '/invest-advise-trade-rules',
    name: 'InvestAdviseTradeRules',
    component: () => import(/* webpackChunkName: "InvestAdviseTradeRules" */ '../views/invest-advise/trade-rules.vue'),
    meta: {
      title: '交易规则'
    }
  },
  {
    path: '/invest-risk-disclosure',
    name: 'InvestAdviseRiskDisclosure',
    component: () => import(/* webpackChunkName: "InvestAdviseRiskDisclosure" */ '../views/invest-advise/risk-disclosure.vue'),
    meta: {
      title: '风险揭示书'
    }
  },
  {
    path: '/income-list',
    name: 'IncomeList',
    component: () => import(/* webpackChunkName: "IncomeList" */ '../views/invest-advise/income-list.vue'),
    meta: {
      title: '收益明细'
    }
  },
  {
    path: '/invest-transaction-log',
    name: 'InvestTransactionLog',
    component: () => import(/* webpackChunkName: "InvestTransactionLog" */ '../views/invest-advise/transaction-log.vue'),
    meta: {
      title: '交易记录'
    }
  },
  {
    path: '/invest-history-achievement',
    name: 'InvestAdviseHistoryAchievement',
    component: () => import(/* webpackChunkName: "InvestAdviseHistoryAchievement" */ '../views/invest-advise/history-achievement.vue'),
    meta: {
      title: '历史业绩'
    }
  },
  {
    path: '/invest-advise-config',
    name: 'InvestAdviseConfig',
    component: () => import(/* webpackChunkName: "InvestAdviseConfig" */ '../views/invest-advise/invest-advise-config.vue'),
    meta: {
      title: '策略资产配置'
    }
  },
  {
    path: '/invest-advise-position',
    name: 'InvestAdvisePosition',
    component: () => import(/* webpackChunkName: "InvestAdvisePosition" */ '../views/invest-advise/invest-advise-position.vue'),
    meta: {
      title: '投资计划'
    }
  },
  {
    path: '/invest-advise-position-detail',
    name: 'InvestAdvisePositionDetail',
    component: () => import(/* webpackChunkName: "InvestAdvisePositionDetail" */ '../views/invest-advise/invest-advise-position-detail.vue'),
    meta: {
      title: '持仓详情'
    }
  },
  {
    path: '/invest-advise-report',
    name: 'InvestAdviseReport',
    component: () => import(/* webpackChunkName: "InvestAdviseReport" */ '../views/invest-advise/invest-advise-report.vue'),
    meta: {
      title: '运作报告'
    }
  },
  {
    path: '/invest-transaction-detail',
    name: 'InvestTransactionDetail',
    component: () => import(/* webpackChunkName: "InvestTransactionDetail" */ '../views/invest-advise/transaction-detail.vue'),
    meta: {
      title: '记录详情'
    }
  },
  {
    path: '/invest-transaction-result',
    name: 'InvestTransactionResult',
    component: () => import(/* webpackChunkName: "InvestTransactionResult" */ '../views/invest-advise/transaction-result.vue'),
    meta: {
      title: '交易结果'
    }
  },
  {
    path: '/invest-buy',
    name: 'InvestBuy',
    component: () => import(/* webpackChunkName: "InvestBuy" */ '../views/invest-advise/buy.vue'),
    meta: {
      title: '买入'
    }
  },
  {
    path: '/invest-sell',
    name: 'InvestSell',
    component: () => import(/* webpackChunkName: "InvestSell" */ '../views/invest-advise/sell.vue'),
    meta: {
      title: '卖出'
    },
    children: [
      {
        path: '/invest-sell/sell/fund-select',
        name: 'InvestSellFunSelect',
        meta: {
          title: '选择充值基金'
        },
        component: () => import(/* webpackChunkName: "InvestSellFunSelect" */ '../views/new-yqb/fund-select.vue')
      }
    ]
  },
  {
    path: '/invest-advise-introduce',
    name: 'InvestAdviseIntroduce',
    component: () => import(/* webpackChunkName: "InvestAdviseIntroduce" */ '../views/invest-advise/invest-advise-introduce.vue'),
    meta: {
      title: '投顾业务介绍'
    }
  },
  {
    path: '/old/buy-result',
    name: 'OldBuyResult',
    component: () => import(/* webpackChunkName: "OldBuyResult" */ '../views/old/buy-result.vue'),
    meta: {
      title: '记录详情'
    }
  },
  {
    path: '/old/sell-result',
    name: 'OldSellResult',
    component: () => import(/* webpackChunkName: "OldSellResult" */ '../views/old/sell-result.vue'),
    meta: {
      title: '记录详情'
    }
  },
  {
    path: '/old/invest-result',
    name: 'OldInvestResult',
    component: () => import(/* webpackChunkName: "OldInvestResult" */ '../views/old/invest-result.vue'),
    meta: {
      title: '记录详情'
    }
  },
  {
    path: '/old/bonus-result',
    name: 'OldBonusResult',
    component: () => import(/* webpackChunkName: "OldBonusResult" */ '../views/old/bonus-result.vue'),
    meta: {
      title: '记录详情'
    }
  },
  {
    path: '/old/plan-result',
    name: 'OldPlanResult',
    component: () => import(/* webpackChunkName: "OldPlanResult" */ '../views/old/plan-result.vue'),
    meta: {
      title: '记录详情'
    }
  },
  {
    path: '/old/else-result',
    name: 'OldElseResult',
    component: () => import(/* webpackChunkName: "OldElseResult" */ '../views/old/else-result.vue'),
    meta: {
      title: '记录详情'
    }
  },
  {
    path: '/microPage',
    name: 'MicroPage',
    title: '微页面',
    meta: {
      title: '\u200E'
      // bridge: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "visitorDetails" */
        '../views/microPage/index.vue'
      )
  },
  {
    path: '/activityModal',
    name: 'ActivityModal',
    meta: {
      title: '资讯内容'
    },
    component: () => import(/* webpackChunkName: "activityModal" */ '../views/microPage/ActivityModal.vue')
  },
  {
    path: '/onlyReadyActivity',
    name: 'OnlyReadyActivity',
    meta: {
      title: '文章详情'
    },
    component: () => import(/* webpackChunkName: "onlyReadyActivity" */ '../views/microPage/OnlyReadyActivity.vue')
  },
  {
    path: '/about',
    name: 'CommonAbout',
    meta: {
      title: '关于我们'
    },
    component: () => import(/* webpackChunkName: "CommonAbout" */ '../views/common/about/index.vue'),
    children: [
      {
        path: 'introduce',
        name: 'CommonAboutIntroduce',
        meta: {
          title: '公司介绍'
        },
        component: () => import(/* webpackChunkName: "CommonAboutIntroduce" */ '../views/common/about/introduce.vue')
      },
      {
        path: 'credentials',
        name: 'CommonAboutCredentials',
        meta: {
          title: '资质展示'
        },
        component: () => import(/* webpackChunkName: "CommonAboutCredentials" */ '../views/common/about/credentials.vue')
      },
      {
        path: 'contact',
        name: 'CommonAboutContact',
        meta: {
          title: '联系我们'
        },
        component: () => import(/* webpackChunkName: "CommonAboutContact" */ '../views/common/about/contact.vue')
      }
    ]
  },
  {
    path: '/common/bulletin',
    name: 'CommonBulletin',
    meta: {
      title: '公告'
    },
    component: () => import(/* webpackChunkName: "CommonBulletin" */ '../views/common/bulletin/index.vue')
  },
  {
    path: '/common/bulletin/detail',
    name: 'CommonBulletinDetail',
    meta: {
      title: '公告详情'
    },
    component: () => import(/* webpackChunkName: "CommonBulletinDetail" */ '../views/common/bulletin/detail.vue')
  },
  {
    path: '/fof',
    name: 'FOF',
    meta: {
      title: 'FOF优选'
    },
    component: () => import(/* webpackChunkName: "FOF" */ '../views/home/FOF.vue')
  },
  {
    path: '/fof/list',
    name: 'FOFList',
    component: () => import(/* webpackChunkName: "FOFList" */ '../views/home/FOF-item.vue')
  },
  {
    path: '/net-worth',
    name: 'NetWorth',
    meta: {
      title: '基金净值'
    },
    component: () => import(/* webpackChunkName: "NetWorth" */ '../views/home/net-worth.vue'),
    children: [
      {
        path: 'search',
        name: 'NetWorthSearch',
        component: () => import(/* webpackChunkName: "NetWorthSearch" */ '../views/fund/search.vue'),
        meta: {
          title: '基金筛选'
        }
      }
    ]
  },
  {
    path: '/common/home/search-self-add',
    name: 'SearchSelfAdd',
    component: () => import(/* webpackChunkName: "SearchSelfAdd" */ '../views/fund/search-self-add.vue'),
    meta: {
      title: '基金筛选'
    }
  },
  {
    path: '/active/index',
    name: 'ActiveIndex',
    meta: {
      title: '龙腾新春活动'
    },
    component: () => import(/* webpackChunkName: "ActiveIndex" */ '../views/active/index.vue')
  },
  {
    path: '/active/politeness',
    name: 'ActiveHaveGift',
    meta: {
      title: '12月奔富有礼'
    },
    component: () => import(/* webpackChunkName: "ActiveIndex" */ '../views/active/politeness.vue')
  },
  {
    path: '/active/rule',
    name: 'ActiveRule',
    meta: {
      title: '12月奔富有礼'
    },
    component: () => import(/* webpackChunkName: "ActiveIndex" */ '../views/active/rule.vue')
  },
  {
    path: '/zhishu-bao',
    name: 'ZhishuBao',
    meta: {
      title: '指数宝'
    },
    component: () => import(/* webpackChunkName: "ZhishuBao" */ '../views/home/zhishu-bao.vue')
  },
  {
    path: '/ranking-list',
    name: 'HomeRankingList',
    meta: {
      title: '复购排行榜'
    },
    component: () => import(/* webpackChunkName: "HomeRankingList" */ '../views/home/ranking-list.vue')
  },
  {
    path: '/group-page',
    name: 'HomeGroupPage',
    meta: {
      title: '投顾组合'
    },
    component: () => import(/* webpackChunkName: "HomeGroupPage" */ '../views/home/group-page.vue')
  },
  {
    path: '/asset-proof',
    name: 'AssetProof',
    meta: {
      title: '资产证明'
    },
    component: () => import(/* webpackChunkName: "AssetProof" */ '../views/asset-proof/index.vue')
  },
  {
    path: '/asset-proof-pre',
    name: 'AssetProofPre',
    meta: {
      title: '资产证明'
    },
    component: () => import(/* webpackChunkName: "AssetProofPre" */ '../views/asset-proof/pre.vue')
  },
  {
    path: '/asset-proof-empty',
    name: 'AssetProofEmpty',
    meta: {
      title: '资产证明'
    },
    component: () => import(/* webpackChunkName: "AssetProofEmpty" */ '../views/asset-proof/empty.vue')
  },
  {
    path: '/asset-proof-private',
    name: 'AssetProofPrivate',
    meta: {
      title: '私募资产证明'
    },
    component: () => import(/* webpackChunkName: "AssetProofPrivate" */ '../views/asset-proof/private.vue')
  },
  {
    path: '/asset-proof-email',
    name: 'AssetProofEmail',
    meta: {
      title: '资产证明'
    },
    component: () => import(/* webpackChunkName: "AssetProofEmail" */ '../views/asset-proof/email.vue')
  },
  {
    path: '/asset-proof/send-success',
    name: 'AssetProofSendSuccess',
    meta: {
      title: '发送申请'
    },
    component: () => import(/* webpackChunkName: "AssetProofSendSuccess" */ '../views/asset-proof/success.vue')
  },
  {
    path: '/asset-proof/send-fail',
    name: 'AssetProofSendFail',
    meta: {
      title: '发送申请'
    },
    component: () => import(/* webpackChunkName: "AssetProofSendFail" */ '../views/asset-proof/fail.vue')
  },
  {
    path: '/asset-proof/detail',
    name: 'AssetProofDetail',
    meta: {
      title: '公募资产证明'
    },
    component: () => import(/* webpackChunkName: "AssetProofSendFail" */ '../views/asset-proof/detail.vue')
  },
  {
    path: '/asset-proof/sm-detail',
    name: 'AssetProofSMDetail',
    meta: {
      title: '私募资产证明'
    },
    component: () => import(/* webpackChunkName: "AssetProofSendFail" */ '../views/asset-proof/smDetail.vue')
  },
  {
    path: '/for-xiaocx',
    name: 'XCX',
    meta: {
      title: '普泽基金'
    },
    component: () => import(/* webpackChunkName: "FOF" */ '../views/home/forXiaocx.vue')
  },
  {
    path: '/new-yqb/buy-type',
    name: 'newYqbBuyType',
    meta: {
      title: '选择转入方式'
    },
    component: () => import(/* webpackChunkName: "newYqbBuyType" */ '../views/new-yqb/buy-type.vue')
  },
  {
    path: '/new-yqb/smart-buy',
    name: 'newYqbSmartBuy',
    meta: {
      title: '智能充值多基金'
    },
    component: () => import(/* webpackChunkName: "newYqbSmartBuy" */ '../views/new-yqb/smart-buy.vue')
  },
  {
    path: '/new-yqb/normal-buy',
    name: 'newYqbNormaltBuy',
    meta: {
      title: '转入活钱宝'
    },
    component: () => import(/* webpackChunkName: "newYqbNormaltBuy" */ '../views/new-yqb/normal-buy.vue'),
    children: [
      {
        path: '/new-yqb/normal-buy/fund-select',
        name: 'newYqbFunSelect',
        meta: {
          title: '转入活钱宝'
        },
        component: () => import(/* webpackChunkName: "newYqbFunSelect" */ '../views/new-yqb/fund-select.vue')
      }
    ]
  },
  {
    path: '/new-yqb/smart-detail',
    name: 'newYqbSmartDetail',
    meta: {
      title: '智能充值多基金'
    },
    component: () => import(/* webpackChunkName: "newYqbSmartDetail" */ '../views/new-yqb/smart-detail.vue')
  },
  {
    path: '/new-yqb/buy-result',
    name: 'newYqbBuyResult',
    meta: {
      title: '交易结果'
    },
    component: () => import(/* webpackChunkName: "newYqbBuyResult" */ '../views/new-yqb/buy-result.vue')
  },
  {
    path: '/new-yqb/sell',
    name: 'newYqbSell',
    meta: {
      title: '转出'
    },
    component: () => import(/* webpackChunkName: "newYqbSell" */ '../views/new-yqb/sell.vue')
  },
  {
    path: '/new-yqb/sell-result',
    name: 'newYqbSellResult',
    meta: {
      title: '交易结果'
    },
    component: () => import(/* webpackChunkName: "newYqbSellResult" */ '../views/new-yqb/sell-result.vue')
  },
  {
    path: '/new-yqb/desc',
    name: 'newYqbDesc',
    meta: {
      title: '说明'
    },
    component: () => import(/* webpackChunkName: "newYqbDesc" */ '../views/new-yqb/desc.vue')
  },
  {
    path: '/new-yqb/sell-order',
    name: 'newYqbSellOrder',
    meta: {
      title: '交易详情'
    },
    component: () => import(/* webpackChunkName: "newYqbSellOrder" */ '../views/new-yqb/sell-order.vue')
  },
  {
    path: '/new-yqb/bonus-order',
    name: 'newYqbBonusOrder',
    meta: {
      title: '交易详情'
    },
    component: () => import(/* webpackChunkName: "newYqbBonusOrder" */ '../views/new-yqb/bonus-order.vue')
  },
  {
    path: '/new-yqb/buy-order',
    name: 'newYqbBuyOrder',
    meta: {
      title: '交易详情'
    },
    component: () => import(/* webpackChunkName: "newYqbBuyOrder" */ '../views/new-yqb/buy-order.vue')
  },
  {
    path: '/new-yqb/buy-order-son',
    name: 'newYqbBuyOrderSon',
    meta: {
      title: '交易详情'
    },
    component: () => import(/* webpackChunkName: "newYqbBuyOrderSon" */ '../views/new-yqb/buy-order-son.vue')
  },
  {
    path: '/new-yqb/sell-order-son',
    name: 'newYqbSellOrderSon',
    meta: {
      title: '交易详情'
    },
    component: () => import(/* webpackChunkName: "newYqbSellOrderSon" */ '../views/new-yqb/sell-order-son.vue')
  },
  {
    path: '/new-yqb/position-detail',
    name: 'newYqbPositionDetail',
    meta: {
      title: '持有明细'
    },
    component: () => import(/* webpackChunkName: "newYqbPositionDetail" */ '../views/new-yqb/position-detail.vue')
  },
  {
    path: '/new-yqb/record-list',
    name: 'newYqbRecordList',
    meta: {
      title: '活钱宝交易记录'
    },
    component: () => import(/* webpackChunkName: "newYqbRecordList" */ '../views/new-yqb/record-list.vue')
  },
  {
    path: '/yiqianbao',
    name: 'Yiqianbao',
    meta: {
      title: '活钱宝'
    },
    component: () => import(/* webpackChunkName: "Yiqianbao" */ '../views/new-yqb/index.vue')
  },
  {
    path: '/yiqianbao-no-asset',
    name: 'YiqianbaoNoAsset',
    meta: {
      title: '活钱宝'
    },
    component: () => import(/* webpackChunkName: "YiqianbaoNoAsset" */ '../views/new-yqb/index-no-asset.vue')
  },
  {
    path: '/fund/transform/search',
    name: 'FundTransformSearch',
    meta: {
      title: '选择转入基金'
    },
    component: () => import(/* webpackChunkName: "FundTransformSearch" */ '../views/fund/transform/search.vue')
  },
  {
    path: '/fund/transform/hold',
    name: 'FundTransformHold',
    meta: {
      title: '选择转入基金'
    },
    component: () => import(/* webpackChunkName: "FundTransformHold" */ '../views/fund/transform/hold.vue')
  },
  {
    path: '/fund/transform/recommend',
    name: 'FundTransformRecommend',
    meta: {
      title: '选择转入基金'
    },
    component: () => import(/* webpackChunkName: "FundTransformRecommend" */ '../views/fund/transform/recommend.vue')
  },
  {
    path: '/fund/transform/transform',
    name: 'FundTransform',
    meta: {
      title: '下单'
    },
    component: () => import(/* webpackChunkName: "FundTransform" */ '../views/fund/transform/transform.vue')
  },
  {
    path: '/fund/transform/trans-result',
    name: 'FundTransformResult',
    meta: {
      title: '交易详情'
    },
    component: () => import(/* webpackChunkName: "FundTransformResult" */ '../views/fund/transform/trans-result.vue')
  },
  {
    path: '/common/position-report/:year',
    name: 'PositionReport',
    meta: {
      title: '年度持仓报告'
    },
    component: () => import(/* webpackChunkName: "PositionReport" */ '../views/common/position-report.vue')
  },
  {
    path: '/due-date',
    name: 'DueDate',
    component: () => import(/* webpackChunkName: "dueDate" */ '../views/my-fund-position/due-date.vue'),
    meta: {
      title: '份额到期日一览'
    }
  },
  {
    path: '/outside-trustee',
    name: 'outsideTrustee',
    meta: {
      title: '转托管转入'
    },
    component: () => import(/* webpackChunkName: "outsideTrustee" */ '../views/fund/trusteeship/out-trustee.vue')
  },
  {
    path: '/outside-trustee/record',
    name: 'outsideTrusteeReord',
    meta: {
      title: '我的申请记录'
    },
    component: () => import(/* webpackChunkName: "outsideTrusteeReord" */ '../views/fund/trusteeship/out-record.vue')
  },
  {
    path: '/outside-trustee/funds',
    name: 'outsideTrusteeFunds',
    meta: {
      title: '转托管转入'
    },
    component: () => import(/* webpackChunkName: "outsideTrusteeFunds" */ '../views/fund/trusteeship/out-trustee-fund.vue')
  },
  {
    path: '/outside-trustee/result',
    name: 'outsideTrusteeResult',
    meta: {
      title: '转托管转入'
    },
    component: () => import(/* webpackChunkName: "outsideTrusteeResult" */ '../views/fund/trusteeship/out-result.vue')
  },
  {
    path: '/fund/quarter-report',
    name: 'fundQuarterReport',
    meta: {
      title: ''
    },
    component: () => import(/* webpackChunkName: "FundQuarterReport" */ '../views/fund/quarter-report/index.vue')
  },
  {
    path: '/common/statistics',
    name: 'CommonIndexStatistics',
    component: () => import(/* webpackChunkName: "CommonIndexMine" */ '../views/common/revenue-statistics.vue'),
    meta: {
      title: '收益统计'
    }
  },
  {
    path: '/account/resign-card-notice',
    name: 'ResignCardNotice',
    meta: {
      title: '重新签约银行卡通知'
    },
    component: () => import(/* webpackChunkName: "ResignCardNotice" */ '../views/account/resign-bank-notice.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  // base: '',
  routes
})




export default router
